import { render, staticRenderFns } from "./StandaloneLayout.vue?vue&type=template&id=5c9a58eb&scoped=true"
import script from "./StandaloneLayout.vue?vue&type=script&lang=js"
export * from "./StandaloneLayout.vue?vue&type=script&lang=js"
import style0 from "./StandaloneLayout.vue?vue&type=style&index=0&id=5c9a58eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a58eb",
  null
  
)

export default component.exports